<button class="closeButton button button-primary w-button" (click)="closeViewer()">
    Close
</button>
<swiper-container navigation="true" pagination="true" class="mySwiper" thumbs-swiper=".mySwiper2"> 
    <swiper-slide *ngFor="let file of data">
        <img src="{{file.mediaUri}}" alt="">
    </swiper-slide>
</swiper-container> 
<swiper-container class="mySwiper2" space-between="5" slides-per-view="10" free-mode="true" breakpoints="{&quot;380&quot;:{&quot;slidesPerView&quot;:4},&quot;1024&quot;:{&quot;slidesPerView&quot;:10}}"> 
    <swiper-slide *ngFor="let file of data">
        <img src="{{file.mediaUri}}" alt="">
    </swiper-slide>
</swiper-container> 